import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import cardsReducer from './slices/cardsSlice';
import transactionsReducer from './slices/transactionsSlice';
import bankAccountsReducer from './slices/bankAccountsSlice';
import uiReducer from './slices/uiSlice';
import kycReducer from './slices/kycSlice';
import notificationsReducer from './slices/notificationsSlice';
import merchantReducer from './slices/merchantSlice';
import adminReducer from './slices/adminSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cards: cardsReducer,
    transactions: transactionsReducer,
    bankAccounts: bankAccountsReducer,
    ui: uiReducer,
    kyc: kycReducer,
    notifications: notificationsReducer,
    merchant: merchantReducer,
    admin: adminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
